import React from 'react';
import Acc_Logo from "./Logo/Acc_Logo.png";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { useMsal } from "@azure/msal-react";


export default function Navbar() {

    const { instance } = useMsal();
    const logoutRequest = {
        account: instance.getAccountByHomeId(localStorage.getItem('homeAccountId'))
    };
    const handleLogout = () => {
        localStorage.clear();
        instance.logoutRedirect(logoutRequest);
    };

    return (
        <nav className="navbar navbar-expand-lg" style={{ backgroundColor: "#7500c0" }}>
            <div className="container-fluid">
                <a className="navbar-brand" href="/">
                    <img src={Acc_Logo} alt="AccentureLogo" style={{ maxWidth: "100px", maxHeight: "100px" }} />
                </a>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarNav">
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            {/* <a className="nav-link active" href="/processDesign" style={{ fontSize: "12px", color: "white" }}>Process Design</a> */}
                        </li>
                    </ul>
                </div>
                <div className="ml-auto">
                    <div onClick={handleLogout} className='mx-3' style={{ cursor: 'pointer' }} title='Logout!'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="white" className="bi bi-power" viewBox="0 0 16 16">
                            <path d="M7.5 1v7h1V1z" />
                            <path d="M3 8.812a5 5 0 0 1 2.578-4.375l-.485-.874A6 6 0 1 0 11 3.616l-.501.865A5 5 0 1 1 3 8.812" strokeWidth="5" />
                        </svg>
                    </div>
                </div>
            </div>
        </nav>
    );
}

